export default __webpack_public_path__ + "static/media/azure.5a694f18.png";